/**
 *
 * This should ideally be satisfied by a generic listing page
 *
 *
 */

import React, { useState, useEffect, useContext } from 'react';

//
import { Space, DatePicker, Form, Typography, Table, Skeleton, Pagination, Input, Popover, Tooltip, Radio } from 'antd';

import { Link } from 'react-router-dom';

import { ModalityGroups } from './../../../../models';

import Select from 'react-select';

import { Location, GlobalContext, Popconfirm, useTranslation, TableComponent, Card, Button, Switch, Tag } from 'soxo-bootstrap-core';

import moment from 'moment-timezone';

import TooltipWrapper from '../../../../components/tooltip-wrapper/tooltip-wrapper';

import './patient-list.scss';

import { OrderedListOutlined, PicCenterOutlined, InfoCircleOutlined } from '@ant-design/icons';

import ReportPreview from './../../../../components/report-preview/report-preview';

import { loadPDF } from '../../../../utils/common.utils';

const { RangePicker } = DatePicker;

const { Search } = Input;

let defaultValue = {
    value: { mod_code: 'all' },
    label: 'All',
};

const filterOptions = [
    {
        label: 'All',
        value: 'all',
    },
    {
        label: 'Reported',
        value: 'reported',
    },
    {
        label: 'Unreported',
        value: 'unreported',
    },
];

/**
 * Patient List
 *
 * @param {*} match
 * @returns
 */
export default function PatientListResearch({
    match,
    mode,
    excludeColpo,
    redirect,
    title,
    filter = 'TECH',
    defaultModality,
    defaultLabel,
    mod_code,
    doctorNote,
    disablePagination,
    reference_id,
    // Make the DoctorNotesScreening read-only
    readOnlyMode,
    test_code,
    // Configuration array for column names
    tableConfig,
    viewerType,
    defaultSizes,
    defaultScaleValue,
    reportConfig = {
        baseUrl: 'http://localhost:3800/',
    },
}) {
    // location params
    var param = Location.search();

    const [range, setRange] = useState([
        moment.tz(param.start_time, process.env.REACT_APP_TIMEZONE).startOf('day'),
        moment.tz(param.end_time, process.env.REACT_APP_TIMEZONE).endOf('day'),
    ]);

    const [groups, setGroups] = useState([]);

    const { user = {}, isMobile } = useContext(GlobalContext);

    const [pending, setPending] = useState(filterOptions[0]);

    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(param.page ? param.page : 1); // Pagination number

    const [limit, setLimit] = useState(20);

    const [patients, setPatients] = useState([]); //Patients list array

    const [view, setView] = useState(isMobile ? true : false); //Need to check this condition

    const [modality, setModality] = useState(defaultValue);

    // console.log(mod_code, defaultModality, defaultLabel, defaultValue)

    const [subModality, setSubModality] = useState('');

    const { t, i18n } = useTranslation(); // To Translate to another language

    const [suboptions, setSuboptions] = useState([]);

    // Number of total records
    const [count, setCount] = useState(0);

    //To disable select box when mamo is defaultModality
    const [disabled, setDisabled] = useState(false);

    if (defaultModality) {
        defaultValue = {
            value: {
                mod_code: mod_code,
                mod_groupptr: defaultModality,
            },
            //default label for default modality
            label: defaultLabel,
        };
    }
    var [query, setQuery] = useState('');

    var [opvalue, setOpvalue] = useState(param.opno || '');

    const [searchValue, setSearchvalue] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [filteredData, setFilteredData] = useState(dataSource);

    useEffect(() => {
        // checking if there is default modality, to disable the modality filter option
        if (defaultModality) {
            setDisabled(true);
        }
        // On url update load the data
        // loadModality()
        if (doctorNote) {
            loadRadiologyList(reference_id);
        } else {
            loadData();
        }
    }, [match.params]);

    useEffect(() => {
        return () => {
            // This will be called when the component unmounts
            defaultValue = {
                value: { mod_code: 'all' },
                label: t('All'),
            };
        };
    }, []);

    /**
     * Load the data
     */
    function loadData(record) {
        let urlParams = Location.search();

        // Match params
        let params = {
            start_time: range[0].format('MM/DD/YYYY'),
            end_time: range[1].format('MM/DD/YYYY'),
            limit: 20,
            modality: defaultValue.value.mod_code,

            ...urlParams,
        };

        // set params for opno search
        // if (urlParams.opno) {
        //     params = {
        //         ...params,
        //         opno: urlParams.opno,
        //     };
        // }

        loadGuestRecords(params);
    }

    useEffect(() => {
        getGroups();
    }, [user]);

    /**
     * load the data
     *
     * @param {*} params
     */

    function loadGuestRecords(params) {
        setLoading(true);
        // Load the data

        ModalityGroups.loadGuests({ ...params, user, mode, excludeColpo, page, limit }).then((result) => {
            setPatients([...result[0]]);

            // If the count is present , update the size of the pagination component
            if (result[0] && result[0][0] && result[0][0].TotalCount) {
                setCount(result[0][0].TotalCount);
            }

            setLoading(false);
        });
    }
    /***
     * Radiology lIst for doctor notes screen
     *
     */
    function loadRadiologyList() {
        //
        setLoading(true);

        // Load the data
        ModalityGroups.getRadiologyList(reference_id).then((result) => {
            setPatients(result.result);

            setLoading(false);
        });
    }

    let values;

    /**
     * On Page Change
     *
     * @param {*} data
     */
    function onPagination(page, limit) {
        setPage(page);

        setLimit(limit);

        Location.search({ page, limit });
    }

    /**
     * Get all the groups
     */
    function getGroups() {
        // get groups
        ModalityGroups.getModality().then((result) => {
            let options = [
                defaultValue,

                ...result.result
                    .filter((item) => item.mod_active === 'Y')
                    .map((record) => {
                        return {
                            value: record,
                            label: record.mod_desc,
                        };
                    }),
            ];

            setGroups(options);

            // In case a default value is present , we have to assign the entire object to react-select
            // component ,that is how the react select would work , check documentation

            if (defaultValue.label !== 'All') {
                values = options.find((option) => option.value.mod_code === mod_code);

                filterModality(values);
            }
        });
    }

    /**
     * On change of datetime
     *
     * @param {*} dt
     */
    function updateTime(dt) {
        setPage(1);
        setRange(dt);
        setSubModality('');

        Location.search({
            page: 1,
            limit: 20,
            start_time: moment(dt[0]).format('MM/DD/YYYY'),
            end_time: moment(dt[1]).format('MM/DD/YYYY'),
        });
    }

    /**
     * Change view
     *
     * @param {*} result
     */
    function changeView(result) {
        setView(result);
    }

    /**
     * Refresh the
     */
    function refresh() {
        setSubModality('');

        loadData();
    }

    /**
     * For search against search text
     * @param {*} event
     */
    function onSearch(value) {
        // setQuery(event.target.value);
        setSearchvalue(value);
        let params = Location.search();

        if (!value) {
            // If the value is not present , we have to remove from the object
            delete params.searchtext;

            setLimit(20);

            setPage(1);

            Location.search(
                {
                    ...params,
                },
                {
                    reset: true,
                }
            );
        } else {
            setLimit(100);

            setPage(1);

            // Append searchtext to search
            Location.search({
                searchtext: value,
            });
        }
    }

    /**
     * For search against opno
     *
     * @param {*} event
     */
    async function onSearchOp(value) {
        setOpvalue(value);
        // let value = value;

        let params = Location.search();

        if (!value) {
            setLimit(20);

            setPage(1);

            // If the value is not present , we have to remove from the
            // object
            delete params.opno;

            Location.search(
                {
                    ...params,
                },
                {
                    reset: true,
                }
            );
        } else {
            setLimit(100);

            setPage(1);

            // Append opno to search
            Location.search({
                opno: value,
            });
        }
    }

    /**
     * Filter by modality
     *
     * @param {*} value
     * @param {*} content
     */
    function filterModality(value, content) {
        setPage(1);

        setModality(value);

        setSubModality('');

        if (value.label !== 'All') {
            ModalityGroups.getModalityGroupItemGroupMap(value.value.mod_groupptr).then((result) => {
                // setPatients(result);
                setSuboptions(
                    result.map((record) => {
                        return {
                            value: record,
                            label: record.itm_desc,
                        };
                    })
                );
            });

            /**Setting url params data */
            /** Setting URL params data */
            Location.search(
                {
                    // opno: opvalue,
                    modality: value.value.mod_code,
                    page: 1,
                    ...(opvalue !== '' && { opno: opvalue }), // Conditionally add 'opn'
                    ...(searchValue !== '' && { searchtext: searchValue }),
                },
                { reset: true }
            );
        } else {
            Location.search(
                {
                    // opno: opvalue,
                    modality: value.value.mod_code,
                    page: 1,
                    ...(opvalue !== '' && { opno: opvalue }),
                    ...(searchValue !== '' && { searchtext: searchValue }), // Conditionally add 'opn'
                },
                { reset: true }
            );
        }
    }

    /**
     * Subfilter
     *
     * @param {*} value
     */
    function subFilterModality(value) {
        /**If submodality unselected */
        if (!value) {
            setSubModality(null);
            Location.search({ modality: modality.value.mod_code, submodality: null });
        } else {
            setSubModality(value);
            Location.search({ submodality: value.value.itm_code });
        }
    }

    const radiologyColumns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (value, item, index) => (page - 1) * limit + index + 1,
        },
        // {
        //     title: t('Date'),

        //     render: (value) => {
        //         return moment(value.process_start_time).format('DD/MM/YYYY');
        //     },
        //     // render: (ele) => {
        //     //    console.log(ele)
        //     // },
        //     key: 'ProcessStartTime',
        // },
        {
            title: t('Modality'),

            dataIndex: 'modality',
            key: 'modality',
            render: (text, record) => {
                if (record.report_type) {
                    return (
                        <Space size="middle">
                            {record.report_type && (
                                <ReportPreview
                                    config={reportConfig}
                                    record={record}
                                    viewerType={viewerType}
                                    defaultSizes={defaultSizes}
                                    defaultScaleValue={defaultScaleValue}
                                />
                            )}
                            {record.pacs_path && (
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={record.pacs_path}
                                    // style={{ marginLeft: '5px' }}
                                >
                                    {t('(PACS)')}
                                </a>
                            )}

                            {/* <a target="_blank" href={record.pacs_path}>View</a> */}
                        </Space>
                    );
                } else {
                    return (
                        <>
                            <Space size="middle">
                                {' '}
                                {record.modality}
                                {/* <Tag color={'red'}> Report Pending</Tag> */}
                                <Tooltip title="Report Pending">
                                    <InfoCircleOutlined style={{ color: 'red' }} />
                                </Tooltip>
                            </Space>
                        </>
                    );
                }
            },
            // filters: filterChoices && filterChoices[0],
            // onFilter: (value, record) => (record.Modality ? record.Modality.indexOf(value) === 0 : null),
        },
        // {
        //     title: t('Report'),
        //     key: 'action',
        //     // fixed: 'right',
        //     render: (text, record) => {
        //         if (record.report_type) {
        //             return (
        //                 <Space size="middle">
        //                     <ReportPreview config={reportConfig} record={record} />

        //                     {/* <a target="_blank" href={record.pacs_path}>View</a> */}
        //                 </Space>
        //             );
        //         }
        //     },
        // },

        // {
        //     title: t('PACS'),
        //     key: 'action',
        //     // fixed: 'right',
        //     render: (text, record) => {
        //         if (record.pacs_path) {
        //             return (
        //                 <Space size="middle">
        //                     <a target="_blank" href={record.pacs_path}>
        //                         {t('View')}
        //                     </a>
        //                 </Space>
        //             );
        //         }
        //     },
        // },

        // {
        //     title: t('Accession No'),
        //     dataIndex: 'accession_no',
        //     key: 'accessionno',
        // },

        {
            title: t('Tech Result'),
            dataIndex: 'tech_result',
            key: 'TechResult',
        },

        {
            width: 100,
            title: t('Tech Remarks'),
            dataIndex: 'tech_description',
            key: 'tech_description',
            render: (tech_description) => {
                return (
                    <>
                        <TooltipWrapper content={tech_description} length={15} />
                    </>
                );
            },
        },

        // {
        //     title: 'Dr Result',
        //     key: 'result',
        //     render: (text, record) => {
        //         const content = (
        //             <div>
        //                 <p>{text.DrRemarks}</p>
        //             </div>
        //         );

        //         return (
        //             <>
        //                 <Popover content={content} title="Remarks">
        //                     {text.DrResult}
        //                 </Popover>
        //             </>
        //         );
        //     },
        // },
    ];

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            // render: (value, item, index) => (options.page - 1) * options.pageSize + index + 1,
            render: (value, item, index) => (page - 1) * limit + index + 1,

            // render: (value, item, index) => page * index + 1,
        },

        {
            title: t('Name'),
            dataIndex: 'Name',
            key: 'name',
        },

        {
            title: t('Date'),
            dataIndex: 'ProcessStartTime',
            key: 'ProcessStartTime',
        },
        {
            title: t('Age'),
            dataIndex: 'Age',
            key: 'age',
        },

        {
            title: t('Gender'),
            key: 'gender',
            render: (record) => {
                return record && record.Gender ? <Tag color={record.Gender === 'Male' ? 'blue' : 'magenta'}>{record.Gender}</Tag> : null;
            },
        },

        // {
        //     title: 'Billed  Date',
        //     dataIndex: 'ProcessStartTime',
        //     key: 'ProcessStartTime',
        // },
        {
            title: t('OP No'),
            key: 'OpNo',
            render: (record) => {
                return record?.opno ? <Tag color="green">{record.opno}</Tag> : null;
            },
        },

        {
            title: t('Modality'),
            dataIndex: 'Modality',
            key: 'Modality',
            // filters: filterChoices && filterChoices[0],
            // onFilter: (value, record) => (record.Modality ? record.Modality.indexOf(value) === 0 : null),
        },

        {
            title: t('Accession No'),
            dataIndex: 'AccessionNo',
            key: 'accessionno',
        },

        {
            title: t('Tech Result'),
            dataIndex: 'TechResult',
            key: 'TechResult',
        },

        {
            title: t('Tech Remarks'),
            dataIndex: 'TechDesc',
            key: 'TechDesc',
        },

        {
            title: t('Dr Result'),
            key: 'result',
            render: (text, record) => {
                const content = (
                    <div>
                        <p>{text.DrRemarks}</p>
                    </div>
                );

                return (
                    <>
                        <Popover content={content} title={t('Remarks')}>
                            {text.DrResult}
                        </Popover>
                    </>
                );
            },
        },

        {
            title: '',
            key: 'action',
            fixed: 'right',
            render: (text, record) => {
                let isPresent = false;

                if (text.DrResult) {
                    isPresent = true;
                }

                return (
                    <Space size="middle">
                        {/* ${record.MODE} */}

                        <Link
                            to={`/${redirect}/${record.opno}?accessionno=${record.AccessionNo}&mode=${isPresent ? 'RAD' : 'TECH'}&opb_id=${
                                record.billid
                            }&item_ptr=${record.template_code}`}
                        >
                            {t('View')}
                        </Link>
                    </Space>
                );
            },
        },
    ];

    // columns
    let tableColumns;
    if (doctorNote) {
        tableColumns = radiologyColumns;
    } else {
        tableColumns = columns;
    }

    // If tableConfig is present, update column titles based on matching keys
    // Update column title based on tableConfig
    if (tableConfig) {
        tableColumns.forEach((col) => {
            const displayText = tableConfig[col.key];
            if (displayText) {
                col.title = displayText;
            }
        });
    }

    // Defining Data source for passing to list
    var dataSource = patients.filter((item) => {
        query = query.toUpperCase();
        // Check for read-only mode and specific test code
        if (readOnlyMode && test_code) {
            // Return true if item's test code matches the given test code
            return item.item.trim() === test_code.trim();
        }
        if (query) {
            if (filter === 'TECH') {
                if (pending.value === 'reported' && item.Name.toUpperCase().indexOf(query) != -1) {
                    return item.TechResult;
                } else if (pending.value === 'unreported' && item.Name.toUpperCase().indexOf(query) != -1) {
                    return !item.TechResult;
                } else if (item.Name.toUpperCase().indexOf(query) != -1) {
                    return true;
                }
            } else if (filter === 'RAD') {
                if (pending.value === 'reported' && item.Name.toUpperCase().indexOf(query) != -1 && item.MODE === 'RAD') {
                    return item.DrResult;
                } else if (pending.value === 'unreported' && item.Name.toUpperCase().indexOf(query) != -1 && item.MODE === 'RAD') {
                    return !item.DrResult;
                } else if (item.Name.toUpperCase().indexOf(query) != -1 && item.MODE === 'RAD') {
                    return true;
                }
            }
        } else {
            if (filter === 'TECH') {
                if (pending.value === 'reported') {
                    return item.TechResult;
                } else if (pending.value === 'unreported') {
                    return !item.TechResult;
                } else {
                    return true;
                }
            } else if (filter === 'RAD') {
                if (pending.value === 'reported') {
                    return item.DrResult;
                } else if (pending.value === 'unreported') {
                    return !item.DrResult;
                } else {
                    return true;
                }
            }
        }
    });

    /**
     * Filters the `dataSource` based on the currently selected radio button filter.
     *
     * Filter rules:
     * - 'normal'    → Includes only items with `tech_result === 'Negative'`.
     * - 'abnormal'  → Includes items where `tech_result` is one of:
     *                 'Positive', 'Mild Abnormality', 'Observations Required'.
     * - 'pending'   → Includes items with `tech_result === 'Pending'`.
     * - 'all'       → Includes all items (default fallback).
     *
     * This effect runs whenever `selectedFilter` changes.
     */
    useEffect(() => {
        const filtered = dataSource.filter((item) => {
            const abnormalValues = ['Positive', 'Mild Abnormality', 'Observations Required'];

            if (selectedFilter === 'normal') {
                return item.tech_result === 'Negative';
            }
            if (selectedFilter === 'abnormal') {
                return abnormalValues.includes(item.tech_result);
            }
            if (selectedFilter === 'pending') {
                return item.tech_result === 'Pending';
            }

            return true; // Default case: 'all'
        });

        setFilteredData(filtered);
    }, [selectedFilter]);

    /**
     * Reapplies full data when `patients` updates and the selected filter is 'all'.
     * Ensures that when the original data source (`patients`) changes (e.g., on fetch),
     * the full list is reloaded if the user has not applied a specific filter.
     */
    useEffect(() => {
        if (dataSource.length && selectedFilter === 'all') {
            setFilteredData(dataSource);
        }
    }, [patients]);

    return (
        <Card className="patient-list card card-shadow">
            {/* Page Header */}

            {doctorNote ? (
                <>
                    <div style={{ margin: '10px 0' }}>
                        <Radio.Group
                            onChange={(e) => {
                                const selectedValue = e.target.value;
                                setSelectedFilter(selectedValue);
                            }}
                            defaultValue="all"
                            buttonStyle="solid"
                        >
                            <Radio value="all">{t('All')}</Radio>
                            <Radio value="abnormal">{t('Abnormal')}</Radio>
                            <Radio value="normal">{t('Normal')}</Radio>
                            <Radio value="pending">{t('Pending')}</Radio>
                        </Radio.Group>
                    </div>
                    <div class="card-header">
                        <div className="card-title">
                            <h3>{t('RADIOLOGY')}</h3>
                        </div>

                        <div className="table-actions">
                            {dataSource.length && !readOnlyMode ? <OpenAllPDF config={reportConfig} records={dataSource} /> : null}
                        </div>
                    </div>
                </>
            ) : (
                <div className="page-header">
                    <div className="left">
                        <Search
                            placeholder={t('Search Page')}
                            allowClear
                            style={{ width: 180, marginTop: '10px', marginBottom: '20px' }}
                            // onChange={onSearch}
                            onSearch={onSearch}
                        />

                        {/**Component to search without repeated api call */}
                        {/* <SearchDebounce
                            placeholder="Enter OP No"
                            value={query}
                            onChange={(value) => {

                                onSearchOp(value);
                                // setQuery(value);
                                // getMedicine(value, category);
                            }}
                        /> */}

                        <Search
                            placeholder={t('Search OP No')}
                            allowClear
                            style={{ width: 180, marginTop: '10px', marginBottom: '20px' }}
                            onSearch={onSearchOp}
                            onChange={(event) => {
                                setOpvalue(event.target.value);
                            }}
                            value={opvalue}
                        />
                    </div>

                    <div className="right" style={{ alignItems: 'end' }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: '10px' }} className="modality-name">
                                <div className="action-header">{t('Filter')}</div>
                                <Select
                                    options={filterOptions}
                                    labelInValue={'mod_desc'}
                                    value={pending}
                                    onChange={(value) => {
                                        setPending(value);
                                    }}
                                    // defaultValue="all"
                                    style={{ width: 120 }}
                                ></Select>
                            </div>

                            {/* not needed for stoptb */}
                            <div style={{ marginRight: '10px' }} className="modality-name">
                                <div className="action-header">{t('Modality')}</div>

                                <Select
                                    options={groups}
                                    // labelInValue={'mod_desc'}
                                    value={modality}
                                    // getOptionLabel={(option) => option.label}
                                    // getOptionValue={(option) => option.value}
                                    onChange={(value) => {
                                        filterModality(value);
                                    }}
                                    defaultValue={modality}
                                    style={{ width: 80 }}
                                    isDisabled={disabled}
                                ></Select>
                            </div>

                            {/* not needed for stoptb */}
                            {/* Filter for Sub Modality */}
                            {modality.label !== 'All' ? (
                                <div style={{ marginRight: '10px' }} className="sub-modality-name">
                                    <div className="action-header">{t('Sub Modality')}</div>
                                    <Select
                                        isClearable={true}
                                        options={suboptions}
                                        value={subModality}
                                        onChange={subFilterModality}
                                        style={{ width: 80 }}
                                    ></Select>
                                </div>
                            ) : null}
                            {/* Filter for Sub Modality Ends */}

                            {/* Filtering data */}
                        </div>

                        {/* Filtering data */}
                        <div className="date-and-fltr" style={{ display: 'flex', marginBottom: '6px' }}>
                            <div>
                                <div className="action-header">{t('Date')}</div>
                                <RangePicker
                                    allowClear={false}
                                    inputReadOnly
                                    format={'DD/MM/YYYY'}
                                    value={range}
                                    onChange={(time) => {
                                        updateTime(time, range);
                                    }}
                                    ranges={{
                                        Today: [moment(), moment()],

                                        Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],

                                        'This Week': [moment().startOf('week'), moment().endOf('week')],

                                        'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],

                                        'This Month': [moment().startOf('month'), moment().endOf('month')],

                                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                    }}
                                />

                                {/* <Button onClick={refresh} type="secondary" size={'small'}>
                                <ReloadOutlined />
                            </Button> */}
                            </div>
                            <div style={{ margin: 'auto' }}>
                                <Switch
                                    defaultChecked={view}
                                    onChange={changeView}
                                    checked={view}
                                    checkedChildren={<OrderedListOutlined />}
                                    unCheckedChildren={<PicCenterOutlined />}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Content Below */}
            {loading ? (
                <>
                    <Skeleton active />
                </>
            ) : (
                <div style={{ overflowX: 'auto', overflowY: 'hidden', minHeight: '850px' }}>
                    <TableComponent
                        className="radioloy-table"
                        scroll={{ x: true }}
                        rowKey={(record) => record.AccessionNo}
                        dataSource={doctorNote ? filteredData : dataSource}
                        {...(doctorNote ? {} : { scroll: { x: true } })}
                        columns={tableColumns}
                        pagination={false}
                    />
                </div>
            )}

            <div className="table-footer">
                {!loading && !disablePagination ? (
                    <Pagination pageSize={limit} showSizeChanger={true} onChange={onPagination} defaultCurrent={page} total={count} />
                ) : null}
            </div>

            {/* Page Header Ends */}
            {doctorNote ? null : <p className="size-hint">{loading ? 'Loading' : dataSource.length} records.</p>}
        </Card>
    );
}

//Mobile view card Section
function CardList({ dataSource, redirect }) {
    return dataSource.map((item, index) => {
        let isPresent = false;

        if (item.DrResult) {
            isPresent = true;
        }
        return (
            <Link
                key={index}
                className="report-item"
                to={`/${redirect}/${item.opno}?accessionno=${item.AccessionNo}&mode=${isPresent ? 'RAD' : 'TECH'}&opb_id=${item.billid}&item_ptr=${
                    item.template_code
                }`}
            >
                <ModalityGroups.GuestCard record={item} />
            </Link>
        );
    });
}

/**
 *
 * A helper Component that opens all pdf
 *
 * @returns
 */
function OpenAllPDF({
    config = {
        type: 'RPT',
    },
    records = [],
}) {
    const [loading, setLoading] = useState(false);

    /**
     * When the button is clicked
     *
     */
    const openAll = async () => {
        setLoading(true);

        const reportPaths = [];

        // let reports = [records[0]];

        await Promise.all(
            records.map(async (report) => {
                if (report.report_type == 'RPT') {
                    const modality_name = report.modality;

                    let path = await loadPDF({
                        report_link: report.report_path,
                        config,
                        type: 'RPT',
                    });

                    reportPaths.push(path);

                    const newWindow = window.open(`${path}`, '_blank');
                    // Wait until the new window is loaded, then set the title
                    newWindow.onload = () => {
                        newWindow.document.title = modality_name;
                    };
                }
            })
        );

        setLoading(false);

        console.log(reportPaths);
    };

    return (
        <>
            <Button onClick={openAll} loading={loading} size={'small'}>
                Open All
            </Button>

            {/* <Popconfirm
                title="Are you sure you want to open all modality reports ? "
                onConfirm={() => openAll()}
                onCancel={() => { }}
                okText="Yes"
                cancelText="No"
            >
                <Button loading={loading} size={'small'} >
                    Open All
                </Button>
            </Popconfirm> */}
        </>
    );
}
